import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/payment-methods/profile/loading';

export const Route = createFileRoute('/_private/settings/payment-methods/$id')({
  pendingComponent: Loading,
});
